import React, { useState, useEffect } from 'react';
import ApexCharts from 'react-apexcharts';
import HeatMapDummy from './Filter 3 Stocks Max Sharpe 1Y-grid.json';
import { ApexOptions } from 'apexcharts';

type HeatMapData = {
  [key: string]: {
    "Outperforming Nifty": number;
    "Return Difference": number;
    "Display String": string;
  };
};

interface HeatMapProps {
  portfolioValue: string;
}

const HeatMap = ({
  portfolioValue}:HeatMapProps) => {
  const [heatmapData, setHeatmapData] = useState<{ name: string; data: any; }[]>([]);
  const [tooltipData, setTooltipData] = useState<{ [key: string]: string[] }>({});
  const [data, setData] = useState<HeatMapData | null >(HeatMapDummy);
  const [isLoading, setIsLoading] = useState(true); // New loading state

  useEffect(() => {
    fetchdata();
  }, []); // Removed data dependency

  const fetchdata = async () => {
    try{ 
      const response = await fetch(
        (process.env.REACT_APP_STOCK_SELECTION || "") + `/Stock-Selection/analysis-fabric-files/${encodeURI(portfolioValue)}/Filter 3 Stocks Max Sharpe 1Y-grid.json`
      );
      const data = await response.json();
      setData(data);
      setIsLoading(false);
      // console.log(data)
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (!isLoading) { // Check if loading is false before transforming data
      const { seriesData, tooltipInfo } = transformData(data);
      setHeatmapData(seriesData);
      setTooltipData(tooltipInfo);
    }
  }, [data, isLoading]); // Add isLoading to dependency array
  

  const transformData = (data:any) => {
    // Initialize a map to collect return differences by year and month
    const heatmapMap: { [key: string]: any[] } = {};
    const tooltipInfo: { [key: string]: any[] }  = {};

    Object.keys(data).forEach(key => {
      const [month, year] = key.split(' ');
       const { "Return Difference": returnDifference, "Display String": displayString } = data[key];

      if (!heatmapMap[year]) {
        heatmapMap[year] = Array(12).fill(null);
      }

      const monthIndex = new Date(`${month} 1, ${year}`).getMonth();
      heatmapMap[year][monthIndex] = returnDifference;

      if (!tooltipInfo[year]) {
        tooltipInfo[year] = Array(12).fill(null);
      }
      tooltipInfo[year][monthIndex] = displayString;
    });

    // Convert the map to the series format required by ApexCharts
    const seriesData = Object.keys(heatmapMap).map(year => ({
      name: year,
      data: heatmapMap[year].map((value, index) => ({
        x: new Date(2020, index, 1).toLocaleString('default', { month: 'short' }),
        y: value
      }))
    }));

    return { seriesData, tooltipInfo };
  };

  const options:ApexOptions = {
    chart: {
      height: 350,
      type: 'heatmap'
    },
    dataLabels: {
      enabled: false
    },
    colors: ['#278E03'],
    plotOptions: {
      heatmap: {
        shadeIntensity: 1,
        radius: 0,
        useFillColorAsStroke: false,
        colorScale: {
          ranges: [
            {
              from: -40,
              to: -1,
              name: 'Negative',
              color: '#AF150B'
            },
            {
              from: 0,
              to: 0,
              name: 'Neutral',
              color: '#E0E0E0'
            },
            {
              from: 1,
              to: 140,
              name: 'Positive',
              color: '#278E03'
            }
          ],
        }
      }
    },
    // title: {
    //   text: 'HeatMap Chart (Return Difference by Month and Year)'
    // },
    xaxis: {
      type: 'category'
    },
    tooltip: {
      y: {
        formatter: (value, { seriesIndex, dataPointIndex }) => {
          const year = Object.keys(tooltipData)[seriesIndex];
          // Check if tooltipData has a defined value for the year
          if (tooltipData[year]) {
            const displayString = tooltipData[year][dataPointIndex];
            if (displayString) {
              return displayString;
            }
          }
          return value !== null && value !== undefined ? value.toString() : 'N/A';
        }
      }
    }
  };

  return (
    <div>
      <ApexCharts options={options} series={heatmapData} type="heatmap" height={350} />
    </div>
  );
};

export default HeatMap;
